import { pathEq, pathOr } from "ramda";
export const participantsFiltersLoading = pathEq(["participantsFilters", "status"], "loading");
export const participantsFiltersList = pathOr([], ["participantsFilters", "list"]);
